<template>
    <div class="login-banner">
        <div class="login-banner__content">
            <div class="login-banner__title">Покупайте автомобили Hyundai с&nbsp;пробегом онлайн</div>

            <div class="login-banner__subtitle">Проверенные автомобили от дилеров Hyundai Certified</div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @use './LoginBanner.scss' as *;
</style>
